import { createSlice } from "@reduxjs/toolkit";

const INITIAL_STATE = {
    isOpen: false,
    modalType: null,
    modalData: null,
}

export const modalSlice = createSlice({
    name: "modal",
    initialState: INITIAL_STATE,
    reducers: {
        openModal: (state, action) => {
            state.isOpen = true;
            state.modalType = action.payload?.modalType || null;
            state.modalData = action.payload?.modalData || null;
        },
        closeModal: (state) => {
            state.isOpen = false;
            state.modalType = null;
            state.modalData = null;
        }
    }
});

export const { openModal, closeModal } = modalSlice.actions;
export default modalSlice.reducer;